export default __webpack_public_path__ + "static/media/misc-books2.fa815065.jpg";